module.exports = __webpack_public_path__ + "images/marketing_site/screenshot1-large.png";